import { z } from "zod";

const clientEnvSchema = z.object({
  VITE_PUBLIC_POSTHOG_KEY: z.string().min(1),
  VITE_PUBLIC_POSTHOG_HOST: z.string().min(1),
});

export const clientEnv = clientEnvSchema.parse({
  VITE_PUBLIC_POSTHOG_KEY: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  VITE_PUBLIC_POSTHOG_HOST: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
});
